import React from 'react';
import { Input } from '@mlc/web-ui-toolkit';

const HiddenUsername = () => (
	<div style={{ display: 'none' }}>
		<Input type="text" value="" name="username" autoComplete="username email" />
	</div>
);

export default HiddenUsername;
